import { RocketAPI } from '@portal/rocket-api-client';
import { createFileRoute } from '@tanstack/react-router';

import Email from 'component/view/Settings/Email';

import { findCachedListItem, requireObjectOperation } from './-guards';

export const Route = createFileRoute('/n/_auth/settings/_layout/email-history/$emailId')({
  beforeLoad: async ({ context, params }) => {
    const emailId = Number(params.emailId);
    const options = RocketAPI.billing.getFindBillingEmailQueryOptions(emailId);

    await requireObjectOperation({
      context,
      options,
      redirectTo: '/n/dashboard',
      cachedItem: findCachedListItem(
        context.queryClient,
        ['/v1/billing/emails'],
        data => (data as { result?: { id?: number }[] } | undefined)?.result,
        email => email.id === emailId
      ),
    });
  },
  component: Email,
});
